<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M7.999999940395355,8C8.549999940395356,8,8.999999940395355,7.55,8.999999940395355,7C8.999999940395355,7,8.999999940395355,1,8.999999940395355,1C8.999999940395355,0.45,8.549999940395356,0,7.999999940395355,0C7.449999940395355,0,6.999999940395355,0.45,6.999999940395355,1C6.999999940395355,1,6.999999940395355,7,6.999999940395355,7C6.999999940395355,7.55,7.449999940395355,8,7.999999940395355,8C7.999999940395355,8,7.999999940395355,8,7.999999940395355,8ZM10.999999940395355,2.68C10.999999940395355,2.68,10.999999940395355,5.02,10.999999940395355,5.02C12.209999940395356,5.93,12.999999940395355,7.37,12.999999940395355,9C12.999999940395355,11.76,10.759999940395355,14,7.999999940395355,14C5.239999940395355,14,2.9999999403953552,11.76,2.9999999403953552,9C2.9999999403953552,7.37,3.7899999403953553,5.94,4.999999940395355,5.02C4.999999940395355,5.02,4.999999940395355,2.68,4.999999940395355,2.68C2.639999940395355,3.81,0.9999999403953552,6.21,0.9999999403953552,9C0.9999999403953552,12.87,4.129999940395355,16,7.999999940395355,16C11.869999940395354,16,14.999999940395355,12.87,14.999999940395355,9C14.999999940395355,6.21,13.359999940395355,3.81,10.999999940395355,2.68C10.999999940395355,2.68,10.999999940395355,2.68,10.999999940395355,2.68Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Power',
} as DefineComponent
</script>
